<div class="row my-row">

    <aside class="col-md-3 my-col" id="sticky-sidebar">
        <app-folders></app-folders>
    </aside>

    <div class="col-12 col-md-9 my-col" id="main">
        <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>

        <div class="row my-row pt-5 pb-3">
            <div class="col-xl my-col">
                <h1>{{ "DIRECTORY.TITLE" | translate }}</h1>
            </div>
        </div>

        <ul class="nav nav-tabs" role="tablist" id="navList">
            <li class="nav-item">
                <a data-target="#directory" class="nav-link active" data-toggle="tab" (click)="activeTab = 'directory'">{{ "DIRECTORY.SEARCH" | translate }}</a>
            </li>

            <li class="nav-item">
                <a data-target="#create" class="nav-link" data-toggle="tab" (click)="activeTab = 'create'">{{ "DIRECTORY.ADD" | translate }}</a>
            </li>
            <li class="nav-item">
                <a data-target="#share" class="nav-link" data-toggle="tab" (click)="activeTab = 'share'">{{ "DIRECTORY.OPTIONS" | translate }}</a>
            </li>
        </ul>

        <div class="tab-content">
          <div *ngIf="activeTab === 'directory'" class="tab-pane active w-100" id="directory">
            <app-directory-form [accessDirectory]="accessDirectory"></app-directory-form>
          </div>
          <div *ngIf="activeTab === 'create'" class="tab-pane active w-100" id="create">
            <app-add-patient-directory></app-add-patient-directory>
          </div>
          <div *ngIf="activeTab === 'share'" class="tab-pane active w-100" id="share">
            <app-share-directory [sharedDirectory]="sharedDirectory" [accessDirectory]="accessDirectory"></app-share-directory>
          </div>
        </div>
    </div>
</div>
